import React, { Component } from "react";
import { CycleIcon, ICONS, PelletGoIcon, SvgIcon } from "../Common/Icons";
import _ from "i18n";
import { Table, Tooltip } from "antd";
import { connect } from "react-redux";
import {
  fetchCollaboratorsCalendar,
  fetchSettingCollaborators,
  fetchCollaboratorsSynthesis
} from "Thunks";
import {
  setFilterCollaborators,
  setFilterYear,
  setSelectedCollaboratorName,
  setFilterZone,
  setFilterBusinessUnit,
  setCollaboratorSettingFilterTitle,
  setSubMenuDirectionToggle,
  setSubMenuDirection,
  setCollaboratorCalendarTab,
  setCapacityPlaningCollaboratorTab,
  setCapacityPlaningCollaboratorDate,
  setCollaboratorRoleGrouped,
  setCapacityPlaningCollaborator
} from "Actions";
import FilterCalendarTable from "./FilterCalendarTable";
import styles from "./CalendarTablePage.local.scss";
import { getTimeByDurationFormat } from "Utils";
import NumberFormat from "react-number-format";
import NotFoundV2 from "../NotFound/NotFoundV2";
import classnames from "classnames";
import { goBack, push } from "react-router-redux";
import SettingPageHeader from "../Common/PageHeader/SettingPageHeader";
import { HORIZONTAL, VERTICAL } from "Config";
import TTPTab from "../Common/TTPTab";
import moment from "moment";
import { inIframe } from "../../utils";
import { NotificationBar } from "../Common/Notification/NotificationBar";

let tabs = [
  {
    id: "CALENDAR",
    label: "Capacité planing"
  },
  {
    id: "SYNTHESIS",
    label: "Synthèse"
  }
];

class CalendarTablePage extends Component {
  collaboratorId;
  collaboratorName;

  constructor(props) {
    super(props);

    this.state = {
      filterFormIsVisible: false,
      isNarrow: true,
      firstLoad: true
    };
    let { id } = this.props.match.params;
    let { name } = this.props.match.params;
    this.collaboratorName = name;
    this.collaboratorId = id;
  }

  componentDidMount() {
    const { dispatch, subMenuDirection, calendarTableFilter } = this.props;

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(false));
    dispatch(setCollaboratorCalendarTab("CALENDAR"));

    if (this.collaboratorId) {
      dispatch(
        setFilterCollaborators([
          {
            value: parseInt(this.collaboratorId, 10),
            label: this.collaboratorName,
            color: "#000000"
          }
        ])
      );
    } else {
      dispatch(setSelectedCollaboratorName(""));
      dispatch(setFilterCollaborators([]));
    }
    if (calendarTableFilter.year.selected.length === 0) {
      dispatch(setFilterYear([new Date().getFullYear().toString()]));
    }
    dispatch(fetchCollaboratorsCalendar());
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setFilterCollaborators([]));
    dispatch(setFilterBusinessUnit([]));
    dispatch(setFilterZone([]));
    dispatch(setFilterYear([]));
  }

  selectTab = activeTab => {
    const { dispatch, calendarTableFilter } = this.props;
    dispatch(setCollaboratorCalendarTab(activeTab));

    if (activeTab === "CALENDAR") {
      dispatch(setFilterYear([new Date().getFullYear().toString()]));

      dispatch(fetchCollaboratorsCalendar());
    } else if (activeTab === "SYNTHESIS") {
      if (calendarTableFilter.year.selected instanceof Array) {
        dispatch(setFilterYear(new Date().getFullYear().toString()));
      }
      dispatch(fetchCollaboratorsSynthesis());
    }
  };

  handleRedirectToCollaboratorSetting = collaboratorName => {
    const { dispatch } = this.props;

    if (collaboratorName.length > 2 || collaboratorName.length === 0) {
      dispatch(setCollaboratorSettingFilterTitle(collaboratorName));
    }
    dispatch(fetchSettingCollaborators());
    dispatch(push("/collaborators-settings"));
  };

  handleRedirectBack = () => {
    this.props.dispatch(goBack());
  };

  handleRedirectCollaboratorCalendar = (collaboratorName, collaboratorId) => {
    const { dispatch } = this.props;

    dispatch(setCapacityPlaningCollaboratorTab("CALENDAR"));
    dispatch(
      push(
        "/capacity-planing/collaborator/" +
          collaboratorName +
          "/" +
          collaboratorId
      )
    );
  };

  handleRedirectCollaboratorCapacityDossiers = (
    collaboratorName,
    collaboratorId
  ) => {
    const { dispatch } = this.props;

    dispatch(setCapacityPlaningCollaboratorTab("MODEL_ALL_CLIENTS"));
    dispatch(
      push(
        "/capacity-planing/collaborator/" +
          collaboratorName +
          "/" +
          collaboratorId
      )
    );
  };
  // handleRoleFilter = selected => {
  //   this.props.dispatch(setFilterOrganization(selected));
  // };
  handleRedirectCollaboratorCapacityPlanning = (
    collaboratorName,
    collaboratorId,
    item
  ) => {
    const { dispatch, calendarTableFilter } = this.props;
    dispatch(
      setCapacityPlaningCollaborator({
        id: collaboratorId,
        name: collaboratorName
      })
    );
    dispatch(setCapacityPlaningCollaboratorTab("MODEL_ALL_CLIENTS"));

    dispatch(setCollaboratorRoleGrouped(item === "Total" ? null : item));

    dispatch(
      setCapacityPlaningCollaboratorDate(
        moment().year() === calendarTableFilter.year.selected
          ? new moment()
          : new moment(calendarTableFilter.year.selected + "-12-31")
      )
    );
    dispatch(
      push(
        "/capacity-planing/collaborator/" +
          collaboratorName +
          "/" +
          collaboratorId
      )
    );
  };

  onChangeNarrowFormat = format => {
    this.setState({ isNarrow: format });
  };
  handleFilterFormIsVisible = isVisible => {
    this.setState({ filterFormIsVisible: isVisible });
  };

  changeFirstLoad = () => {
    this.setState({ firstLoad: false });
  };

  renderNoCollaboratorSelected = () => {
    return (
      <NotFoundV2
        errorPageType={"ACCESS_DENIED"}
        text={_("selectCollaborator")}
        buttonIgnored={this.props.embedded}
      />
    );
  };
  renderError = error => {
    const year = error.title.substring(
      error.title.lastIndexOf("(") + 1,
      error.title.lastIndexOf(")")
    );

    if (error.code === 170148) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={_("noAnnualCalendar") + year + _("annualCalendarNotConfig")}
          buttonIgnored={this.props.embedded}
        />
      );
    } else {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={"errorOccured"}
          buttonIgnored={this.props.embedded}
        />
      );
    }
  };

  renderTotalComponent = (total, record, type, year) => {
    let { isNarrow } = this.state;
    const { data } = this.props;
    let freeLancerObjective =
      data["isFreelancer_" + year] !== undefined
        ? data["isFreelancer_" + year][year].objective
        : null;
    if (total == null) {
      return (
        <span className={"balance-sheet-td-component"}>
          <span className={"balance-sheet-td-value"} />
        </span>
      );
    }

    if (
      record.TYPE === "Heures non facturable" ||
      record.TYPE === "Heures à prester" ||
      record.TYPE === "Heures à prester facturables" ||
      record.TYPE === "Heures à prester totales" ||
      record.TYPE === "Balance des heures à prester" ||
      record.TYPE === "Prestas TimeSheet" ||
      record.TYPE === "Objectif" ||
      record.TYPE === "Budget annuel affecté"
    ) {
      return (
        <span
          className={`balance-sheet-td-component`}
          style={{
            backgroundColor: type === "TOTAL" ? "#DEE2E6" : "#f5e1bf",
            borderRadius: "5px"
          }}
        >
          <span
            className={classnames(
              "balance-sheet-td-value",
              isNarrow ? "format-narrow" : ""
            )}
            style={{
              color:
                total < 0
                  ? "#06D9B1"
                  : total > 0 && record.TYPE === "Balance des heures à prester"
                    ? "#fe3745"
                    : record.TYPE === "Heures à prester facturables"
                      ? "#205483"
                      : "#29394d",
              backgroundColor: type === "TOTAL" ? "#DEE2E6" : "#f5e1bf",
              fontSize:
                !isNarrow &&
                type === "SOLDE" &&
                (record.TYPE === "Heures à prester" ||
                  record.TYPE === "Jours à prester") &&
                data["isFreelancer_" + year] !== undefined &&
                data["isFreelancer_" + year][year].freelancer === true
                  ? "13px"
                  : isNarrow
                    ? "12px"
                    : "14px"
            }}
          >
            {total > 0 &&
            (record.TYPE !== "Balance des heures à prester" &&
              record.TYPE !== "Heures non facturable")
              ? getTimeByDurationFormat(Math.abs(total))
              : total > 0 &&
                (record.TYPE === "Balance des heures à prester" ||
                  record.TYPE === "Heures non facturable")
                ? "-" + getTimeByDurationFormat(Math.abs(total))
                : getTimeByDurationFormat(Math.abs(total))}
            {type === "SOLDE" &&
              (record.TYPE === "Heures à prester" ||
                record.TYPE === "Heures à prester facturables" ||
                record.TYPE === "Heures à prester totales") &&
              data["isFreelancer_" + year] !== undefined &&
              data["isFreelancer_" + year][year].freelancer === true && (
                <Tooltip
                  placement="bottom"
                  title={
                    <div style={{ textAlign: "left", width: "200%" }}>
                      <div>
                        {_("objectif")} :{getTimeByDurationFormat(
                          parseFloat(freeLancerObjective)
                        )}
                      </div>
                    </div>
                  }
                >
                  <img
                    data-for="info__undefined"
                    data-tip=""
                    className={styles.info_icon}
                    src="/img/icons/info.svg"
                    alt=""
                    currentitem="false"
                  />{" "}
                </Tooltip>
              )}
          </span>
        </span>
      );
    } else {
      return (
        <span
          className={`balance-sheet-td-component`}
          style={{
            backgroundColor: type === "TOTAL" ? "#DEE2E6" : "#f5e1bf",
            borderRadius: "5px"
          }}
        >
          <span
            className={classnames(
              "balance-sheet-td-value",
              isNarrow ? "format-narrow" : ""
            )}
          >
            <NumberFormat
              value={Math.abs(total)}
              displayType={"text"}
              thousandSeparator={"."}
              decimalSeparator={","}
            />
            {type === "SOLDE" &&
              record.TYPE === "Jours à prester" &&
              data["isFreelancer_" + year] !== undefined &&
              data["isFreelancer_" + year][year].freelancer === true && (
                <span>
                  <Tooltip
                    placement="left"
                    title={
                      <div style={{ textAlign: "left", width: "auto" }}>
                        {data["isFreelancer_" + year][year][
                          "freelancerOpenDays"
                        ].diff < 0 ? (
                          <span>
                            {_("Attention il manque")}{" "}
                            {Math.abs(
                              data["isFreelancer_" + year][year][
                                "freelancerOpenDays"
                              ].diff
                            )}
                            {" jours pour atteindre l'objectif annuel"}
                          </span>
                        ) : (
                          <span style={{ textAlign: "left", width: "auto" }}>
                            {_("Jours ouvrable selon le régime")} :{" "}
                            {
                              data["isFreelancer_" + year][year][
                                "freelancerOpenDays"
                              ].openDays
                            }
                          </span>
                        )}
                      </div>
                    }
                  >
                    <img
                      data-for="info__undefined"
                      data-tip=""
                      className={styles.info_icon}
                      src={
                        data["isFreelancer_" + year][year]["freelancerOpenDays"]
                          .diff < 0
                          ? "/img/icons/info_red.svg"
                          : "/img/icons/info_green.svg"
                      }
                      alt=""
                      currentitem="false"
                    />{" "}
                  </Tooltip>
                  {data["isFreelancer_" + year][year]["freelancerOpenDays"]
                    .diff < 0 &&
                    Object.keys(data["isFreelancer_" + year])[0] ===
                      new Date().getFullYear().toString() && (
                      <Tooltip placement="top" title={"Modifier le régime"}>
                        <span>
                          <span
                            className={classnames(
                              "open-button",
                              styles.redirect_icon
                            )}
                          >
                            <span
                              onClick={() =>
                                this.handleRedirectToCollaboratorSetting(
                                  data["isFreelancer_" + year][year][
                                    "freelancerOpenDays"
                                  ].name
                                )
                              }
                            >
                              {<PelletGoIcon />}
                            </span>
                          </span>
                        </span>
                      </Tooltip>
                    )}
                </span>
              )}
          </span>
        </span>
      );
    }
  };
  renderSynthesisTdComponent = (item, value, record) => {
    if (value == null) {
      return (
        <span className={"balance-sheet-td-component"}>
          <span className={"balance-sheet-td-value"} />
        </span>
      );
    }

    if (
      item === "Heures à prester" ||
      item === "solde" ||
      item === "Budget affecté"
    ) {
      return (
        <span
          className={classnames(
            "balance-sheet-td-component",
            record.COLLABORATOR === "TOTAL"
              ? "capacity-planning-total"
              : "capacity-planning-table"
          )}
        >
          <span
            style={{ fontSize: "13px" }}
            className={classnames("balance-sheet-td-value")}
          >
            {getTimeByDurationFormat(Math.abs(value))}
          </span>
        </span>
      );
    } else {
      if (
        (item === "SUPERVISOR" ||
          item === "GD" ||
          item === "GE" ||
          item === "SE" ||
          item === "SCAN_OP" ||
          item === "Délégué") &&
        record.COLLABORATOR !== "TOTAL"
      ) {
        return (
          <span
            className={classnames(
              "balance-sheet-td-component",
              record.COLLABORATOR === "TOTAL"
                ? "capacity-planning-total"
                : item === "Total"
                  ? "capacity-planning-objective"
                  : "capacity-planning-results"
            )}
          >
            <span
              style={{ fontSize: "13px" }}
              className={classnames("balance-sheet-td-value")}
            >
              {Math.abs(value)}
            </span>

            <Tooltip
              placement="bottom"
              title={"Détails"}
              class="columns small-12 large-6"
            >
              <span
                className={styles.redirect_icon}
                onClick={() =>
                  this.handleRedirectCollaboratorCapacityPlanning(
                    record.COLLABORATOR,
                    record.col_id,
                    item
                  )
                }
              >
                <SvgIcon icon={ICONS.REDIRECT} />
              </span>
            </Tooltip>
          </span>
        );
      } else {
        return (
          <span
            className={classnames(
              "balance-sheet-td-component",
              record.COLLABORATOR === "TOTAL"
                ? "capacity-planning-total"
                : item === "Total"
                  ? "capacity-planning-objective"
                  : "capacity-planning-results"
            )}
          >
            <span
              style={{ fontSize: "13px" }}
              className={classnames("balance-sheet-td-value")}
            >
              <NumberFormat
                value={Math.abs(value)}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
              />
            </span>
            {record.COLLABORATOR !== "TOTAL" &&
              item !== "Orphelin" && (
                <Tooltip
                  placement="bottom"
                  title={"Détails"}
                  class="columns small-12 large-6"
                >
                  <span
                    className={styles.redirect_icon}
                    onClick={() =>
                      this.handleRedirectCollaboratorCapacityPlanning(
                        record.COLLABORATOR,
                        record.col_id,
                        item
                      )
                    }
                  >
                    <SvgIcon icon={ICONS.REDIRECT} />
                  </span>
                </Tooltip>
              )}
          </span>
        );
      }
    }
  };
  renderCalendarTdComponent = (value, record) => {
    let { isNarrow } = this.state;
    if (value == null) {
      return (
        <span className={"balance-sheet-td-component"}>
          <span className={"balance-sheet-td-value"} />
        </span>
      );
    }

    if (
      record.TYPE === "Balance des heures à prester" ||
      record.TYPE === "Prestas TimeSheet" ||
      record.TYPE === "Objectif" ||
      record.TYPE === "Budget annuel affecté"
    ) {
      return (
        <span
          className={classnames(
            "balance-sheet-td-component",
            record.TYPE === "Objectif"
              ? "capacity-planning-objective"
              : "capacity-planning-results"
          )}
        >
          <span
            className={classnames(
              "balance-sheet-td-value",
              isNarrow ? "format-narrow" : ""
            )}
            style={{
              color:
                value < 0
                  ? "#06D9B1"
                  : value > 0 && record.TYPE === "Balance des heures à prester"
                    ? "#fe3745"
                    : "#29394d"
            }}
          >
            {value < 0
              ? getTimeByDurationFormat(Math.abs(value))
              : value > 0 && record.TYPE === "Balance des heures à prester"
                ? "-" + getTimeByDurationFormat(Math.abs(value))
                : getTimeByDurationFormat(Math.abs(value))}
          </span>
        </span>
      );
    } else {
      return (
        <span
          className={classnames(
            "balance-sheet-td-component",
            record.TYPE === "Jours à prester" ||
            record.TYPE === "Heures non facturable" ||
            record.TYPE === "Heures à prester facturables" ||
            record.TYPE === "Heures non facturable" ||
            record.TYPE === "Heures à prester totales"
              ? "capacity-planning-paid-days"
              : "capacity-planning-table"
          )}
        >
          <span
            className={classnames(
              "balance-sheet-td-value",
              isNarrow ? "format-narrow" : ""
            )}
            style={{
              color:
                record.TYPE === "Heures à prester facturables" ? "#205483" : ""
            }}
          >
            {record.TYPE === "Heures à prester facturables" ||
            record.TYPE === "Heures non facturable" ||
            record.TYPE === "Heures à prester totales" ? (
              value < 0 ? (
                getTimeByDurationFormat(Math.abs(value))
              ) : value > 0 && record.TYPE === "Heures non facturable" ? (
                "-" + getTimeByDurationFormat(Math.abs(value))
              ) : (
                getTimeByDurationFormat(Math.abs(value))
              )
            ) : (
              <NumberFormat
                value={Math.abs(value)}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
              />
            )}
          </span>
        </span>
      );
    }
  };

  renderCollaboratorsSynthesisTable = year => {
    const {
      synthesisColumnsHours,
      synthesisColumnsNumbers,
      synthesisData
    } = this.props;

    let columns = [];
    if (synthesisData[year] !== undefined && synthesisData[year].length) {
      columns = [
        {
          title: "COLLABORATOR",
          dataIndex: "COLLABORATOR",
          key: "COLLABORATOR",
          render: (text, record) => (
            <span
              className={classnames("balance-sheet-td-component")}
              style={{
                borderRadius: "5px",
                backgroundColor:
                  record.COLLABORATOR === "TOTAL"
                    ? "rgb(200, 205, 210)"
                    : "#f1f2f4"
              }}
            >
              <span className={"balance-sheet-key-indicator"}>
                <span
                  className={
                    text && text.length >= 46 ? "balance-sheet-label-wrap" : ""
                  }
                >
                  <div
                    style={{
                      textAlign: "left",
                      width: "83%",
                      fontSize: "12px"
                    }}
                    className={classnames(
                      "balance-sheet-td-value",
                      text && text.length >= 30 ? "label-wrap" : ""
                    )}
                  >
                    {text}
                  </div>
                </span>
              </span>
            </span>
          ),
          width: 200,
          fixed: "left"
        }
      ];
    }
    synthesisColumnsHours.forEach((item, i) => {
      columns.push({
        title:
          item === "Budget affecté"
            ? _("budgetH")
            : item === "Heures à prester"
              ? _("PrestaTs")
              : item,
        width: 170,
        dataIndex: item,
        key: item,
        render: (text, record) =>
          this.renderSynthesisTdComponent(item, text, record)
      });
    });

    synthesisColumnsNumbers.forEach((item, i) => {
      columns.push({
        title:
          item === "Total" ? (
            <div>
              {item}
              &nbsp;
              <Tooltip
                placement="top"
                title={
                  <div style={{ textAlign: "justify" }}>
                    <div>{_("totalCollaboratorFolderInfo")}</div>
                  </div>
                }
              >
                <img
                  data-for="info__undefined"
                  data-tip=""
                  className={styles.info_icon}
                  src="/img/icons/info_gris.svg"
                  alt=""
                  currentitem="false"
                />{" "}
              </Tooltip>
            </div>
          ) : (
            _(item)
          ),
        width: 170,
        dataIndex: item,
        key: item,
        render: (text, record) =>
          this.renderSynthesisTdComponent(item, text, record)
      });
    });

    return synthesisData.length === 0 ? (
      <NotFoundV2
        errorPageType={"ACCESS_DENIED"}
        text={_("no data found")}
        buttonIgnored={true}
      />
    ) : (
      <div>
        <Table
          columns={columns}
          dataSource={synthesisData[year]}
          scroll={{ x: 1597, y: 800 }}
          pagination={false}
        />
      </div>
    );
  };

  renderCollaboratorCalendarTable = year => {
    const { months, data } = this.props;
    let { isNarrow } = this.state;

    let columns = [];

    if (data[year].length) {
      columns = [
        {
          title: "TYPE",
          dataIndex: "TYPE",
          key: "TYPE",
          render: (text, record) => (
            <span
              className={classnames(
                "balance-sheet-td-component",
                record.TYPE === "Heures à prester" ||
                record.TYPE === "Balance des heures à prester" ||
                record.TYPE === "Prestas TimeSheet" ||
                record.TYPE === "Budget annuel affecté"
                  ? "capacity-planning-results"
                  : "",
                record.TYPE === "Heures non facturable" ||
                record.TYPE === "Jours à prester" ||
                record.TYPE === "Heures à prester facturables" ||
                record.TYPE === "Heures à prester totales"
                  ? "capacity-planning-paid-days"
                  : record.TYPE === "Objectif"
                    ? "capacity-planning-objective"
                    : "capacity-planning-table"
              )}
              style={{ borderRadius: "5px" }}
            >
              <span className={"balance-sheet-key-indicator"}>
                <span
                  className={
                    text && text.length >= 46 ? "balance-sheet-label-wrap" : ""
                  }
                >
                  <div
                    style={{
                      textAlign: "left",
                      width: "83%"
                    }}
                    className={classnames(
                      "balance-sheet-td-value",
                      text && text.length >= 30 ? "label-wrap" : "",
                      isNarrow ? "format-narrow" : ""
                    )}
                  >
                    {text}
                  </div>
                </span>
              </span>
            </span>
          ),
          width: isNarrow ? 190 : 300,
          fixed: "left"
        }
      ];
    }
    months.forEach((item, i) => {
      columns.push({
        title: item,
        width: isNarrow ? 70 : 130,
        dataIndex: item,
        key: item,
        render: (text, record) => this.renderCalendarTdComponent(text, record)
      });
    });

    columns.push({
      title: "TOTAL",
      width: isNarrow ? 85 : 140,
      dataIndex: "TOTAL",
      key: "TOTAL",
      fixed: "right",
      render: (text, record) =>
        this.renderTotalComponent(text, record, "TOTAL", year)
    });

    columns.push({
      title: "SOLDE",
      width: isNarrow ? 100 : 140,
      dataIndex: "SOLDE",
      key: "SOLDE",
      fixed: "right",
      render: (text, record) =>
        this.renderTotalComponent(text, record, "SOLDE", year)
    });

    return data.length === 0 ? (
      <NotFoundV2
        errorPageType={"ACCESS_DENIED"}
        text={_("no data found")}
        buttonIgnored={true}
      />
    ) : (
      <div>
        <Table
          columns={columns}
          dataSource={data[year]}
          scroll={{ x: isNarrow ? 1243 : 2176 }}
          size="small"
          pagination={false}
          sticky
        />
      </div>
    );
  };

  renderRedirectCollaboratorCalendar = () => {
    const { calendarTableFilter } = this.props;

    if (
      calendarTableFilter.collaborator.selected.length === 1 &&
      this.collaboratorId
    ) {
      return (
        <div style={{ marginLeft: "auto", display: "flex" }}>
          <button
            className="btn secondary text-uppercase"
            onClick={() =>
              this.handleRedirectCollaboratorCapacityDossiers(
                this.collaboratorName,
                this.collaboratorId
              )
            }
          >
            <SvgIcon icon={ICONS.FINANCIAL_PAGE_ICON} />
            {_("Capacity Dossier")}
          </button>
          <button
            className="btn secondary text-uppercase"
            onClick={() =>
              this.handleRedirectCollaboratorCalendar(
                this.collaboratorName,
                this.collaboratorId
              )
            }
          >
            <SvgIcon icon={ICONS.FINANCIAL_PAGE_ICON} />
            {_("Calendar")}
          </button>
        </div>
      );
    } else if (calendarTableFilter.collaborator.selected.length === 1) {
      let collaboratorName = calendarTableFilter.collaborator.selected[0].label;
      let collaboratorId = calendarTableFilter.collaborator.selected[0].value;
      return (
        <div style={{ marginLeft: "auto", display: "flex" }}>
          <button
            className="btn secondary text-uppercase"
            onClick={() =>
              this.handleRedirectCollaboratorCapacityDossiers(
                collaboratorName,
                collaboratorId
              )
            }
          >
            <SvgIcon icon={ICONS.FINANCIAL_PAGE_ICON} />
            {_("Capacity Dossier")}
          </button>
          <button
            className="btn secondary text-uppercase"
            onClick={() =>
              this.handleRedirectCollaboratorCalendar(
                collaboratorName,
                collaboratorId
              )
            }
          >
            <SvgIcon icon={ICONS.FINANCIAL_PAGE_ICON} />
            {_("Calendar")}
          </button>
        </div>
      );
    } else {
      return "";
    }
  };

  render() {
    let {
      fetching,
      fetched,
      error,
      data,
      calendarTableFilter,
      activeTab,
      resultCount,
      synthesisFetched,
      synthesisError
    } = this.props;
    let { isNarrow, firstLoad } = this.state;
    let years =
      calendarTableFilter.year.selected instanceof Array &&
      calendarTableFilter.year.selected.length > 0
        ? calendarTableFilter.year.selected.sort(function(a, b) {
            return b - a;
          })
        : [new Date().getFullYear().toString()];
    let selectedYear =
      calendarTableFilter.year.selected instanceof Array
        ? new Date().getFullYear().toString()
        : calendarTableFilter.year.selected;
    let collaborator =
      calendarTableFilter.collaborator.selected.length === 1 ? "DE :  " : " ";
    let collaboratorName =
      calendarTableFilter.collaborator.selected.length === 1
        ? calendarTableFilter.collaborator.selected[0].label
        : "";
    return (
      <div>
        {inIframe() === false && (
          <div style={{ marginBottom: "10px" }}>
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}
        <SettingPageHeader
          title={_("capacityPlaning") + " " + collaborator}
          name={collaboratorName}
          onBack={() => this.handleRedirectBack()}
          customAddOn={this.renderRedirectCollaboratorCalendar()}
        />

        <div className="ttp-tab-container">
          <div className="rmodal__center" style={{ paddingBottom: "7%" }}>
            {activeTab === "CALENDAR" &&
              !fetching &&
              error &&
              this.renderError(error)}

            {activeTab === "SYNTHESIS" &&
              !fetching &&
              synthesisError &&
              this.renderError(synthesisError)}

            <div className={styles.resizable}>
              {/***************  capacityPlanning viewer body *************/}
              <div>
                <div className={`ttp-tab-container ${styles.container}`}>
                  {/* {this.renderCapacityPlanningTitle()} */}
                  <div className={styles.tab_bar}>
                    {fetched &&
                      !synthesisError &&
                      !error && (
                        <TTPTab
                          tabs={tabs}
                          activeTab={activeTab}
                          selectTab={this.selectTab}
                        />
                      )}
                  </div>
                  <div className={styles.filter_margin}>
                    <div className="row align-center medium-12">
                      {fetched &&
                        !synthesisError &&
                        !error && (
                          <FilterCalendarTable
                            handleFilterFormIsVisible={
                              this.handleFilterFormIsVisible
                            }
                            firstLoad={this.changeFirstLoad}
                            isFirstLoad={firstLoad}
                            collaboratorId={this.collaboratorId}
                            activeTab={activeTab}
                            label={_("collaboratorNumber")}
                            nbResult={resultCount}
                          />
                        )}
                    </div>
                  </div>
                  {activeTab === "CALENDAR" &&
                    !firstLoad &&
                    !fetching &&
                    calendarTableFilter.collaborator.selected.length === 0 &&
                    this.renderNoCollaboratorSelected()}
                  <div>
                    {activeTab === "CALENDAR" &&
                      fetched &&
                      !fetching &&
                      !error &&
                      ((!firstLoad &&
                        calendarTableFilter.collaborator.selected.length > 0) ||
                        (firstLoad &&
                          (calendarTableFilter.collaborator.selected.length ===
                            0 ||
                            calendarTableFilter.collaborator.selected.length >
                              0))) && (
                        <div className={styles.narrow_selected}>
                          <div className={styles.selected}>
                            <div
                              className={
                                isNarrow
                                  ? styles.narrow_active
                                  : styles.narrow_inactive
                              }
                              style={{ width: "114px!important" }}
                            >
                              <div
                                className={
                                  isNarrow ? styles.narrow_label : styles.label
                                }
                              >
                                {_("format narrow")}
                              </div>
                              <span
                                onClick={() =>
                                  this.onChangeNarrowFormat(!isNarrow)
                                }
                              >
                                <div className={styles.first_span} />
                                <div className={styles.second_span} />
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    {fetching ? (
                      <div className={styles.ripple_loading}>
                        <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                      </div>
                    ) : fetched && activeTab === "CALENDAR" ? (
                      <div>
                        {!error &&
                          ((!firstLoad &&
                            calendarTableFilter.collaborator.selected.length >
                              0) ||
                            (firstLoad &&
                              (calendarTableFilter.collaborator.selected
                                .length === 0 ||
                                calendarTableFilter.collaborator.selected
                                  .length > 0))) &&
                          years.map(year => {
                            return (
                              <div>
                                <div className={styles.table_label}>
                                  <CycleIcon /> {_("capacityPlaning")} :{" "}
                                  <span className={styles.table_year}>
                                    {year}
                                  </span>
                                </div>
                                {data[year] ? (
                                  this.renderCollaboratorCalendarTable(year)
                                ) : (
                                  <span
                                    className={styles.year_data_ripple_loading}
                                  >
                                    <img
                                      src={"/img/Ripple-1s-150px.svg"}
                                      alt=""
                                      style={{ marginTop: "7%" }}
                                    />
                                  </span>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    ) : (
                      !synthesisError &&
                      synthesisFetched &&
                      activeTab === "SYNTHESIS" && (
                        <div>
                          {" "}
                          {this.renderCollaboratorsSynthesisTable(selectedYear)}
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  lng: state.params.lng,
  fetching:
    state.calendarTable.calendar.fetching ||
    state.calendarTable.synthesis.fetching,
  fetched: state.calendarTable.calendar.fetched,
  synthesisFetched: state.calendarTable.synthesis.fetched,
  data: state.calendarTable.calendar.data,
  synthesisData: state.calendarTable.synthesis.data,
  resultCount: state.calendarTable.synthesis.resultCount,
  months: state.calendarTable.calendar.months,
  synthesisColumnsHours: state.calendarTable.synthesis.columnsHours,
  synthesisColumnsNumbers: state.calendarTable.synthesis.columnsNumbers,
  selectedCollaborator: state.calendarTable.calendar.selectedCollaborator,
  calendarTableFilter: state.calendarTable.filter,
  error: state.calendarTable.calendar.error,
  synthesisError: state.calendarTable.synthesis.error,
  subMenuDirection: state.params.subMenuDirection,
  activeTab: state.calendarTable.calendar.tab,
  role: state.capacityPlaning.collaborator.filter.role
});

export default connect(mapStateToProps)(CalendarTablePage);



// WEBPACK FOOTER //
// ./src/components/CalendarTable/CalendarTablePage.js